import AnyColor, { HexColor } from "@mapmycustomers/shared/types/AnyColor";

enum Preset {
  BLUE = "blue",
  GREEN = "green",
  RED = "red",
  YELLOW = "yellow",
  VIOLET = "violet",
  ORANGE = "orange",
  GREY = "grey",
}

const presetColors: Record<Preset, HexColor[]> = {
  [Preset.BLUE]: ["#cbd8f8", "#f5f7fe"] as HexColor[],
  [Preset.GREEN]: ["#c8ecdd", "#e9f7f1"] as HexColor[],
  [Preset.GREY]: ["#787e8a26", "#787e8a08"] as HexColor[],
  [Preset.ORANGE]: ["#ff6f1b40", "#ff6f1b0d"] as HexColor[],
  [Preset.RED]: ["#ffd5d5", "#ffd5d5"] as HexColor[],
  [Preset.VIOLET]: ["#951ce440", "#951ce405"] as HexColor[],
  [Preset.YELLOW]: ["#fdefce", "#fdefce1a"] as HexColor[],
};

export const findPreset = (colors?: AnyColor[]): Preset | undefined =>
  (Object.values(Preset) as Preset[]).find(
    (preset) =>
      presetColors[preset].length === colors?.length &&
      presetColors[preset].every((color, index) => color === colors[index])
  );

export const getColors = (preset: Preset): HexColor[] => presetColors[preset];

export default Preset;
